import PropTypes from "prop-types";
import classnames from "classnames";
import styles from "./Pill.css";
import SinglePageAppLink from "../SinglePageAppLink";

const Pill = ({ friendlyName, linkUrl, extraClassName }) => (
  <li className={classnames(styles.pillWrapper, extraClassName)}>
    <SinglePageAppLink
      href={linkUrl}
      className={styles.pill}
      label={friendlyName}
    />
  </li>
);

Pill.propTypes = {
  friendlyName: PropTypes.string.isRequired,
  linkUrl: PropTypes.string.isRequired,
  extraClassName: PropTypes.string
};

export default Pill;
